<template>
  <div class="result-list">
    <ContentsBoxGold>
      <h1 class="title">
        <div class="text">
          <img
            :src="require(`@images/result/${locale}/title.png`)"
            :alt="$t('text001', null, 'localeResult')"
          >
        </div>
      </h1>
      <ResultNav />
      <table class="ranking-table">
        <thead>
          <tr>
            <th class="ranking" v-html="$t('text015', null, 'localeResult')" />
            <th class="name" v-html="$t('text016', null, 'localeResult')" />
            <th class="vote" v-html="$t('text017', null, 'localeResult')" />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,i) in ranklist($route.query.page)" :key="i">
            <td class="ranking" v-html="item.rank" />
            <td class="name">
              <p class="another-name" v-html="heroName(item.heroId).nickname" />
              <p v-html="heroName(item.heroId).name" />
            </td>
            <td class="vote" v-html="localeFigure(item.voteCount)" />
          </tr>
        </tbody>
      </table>

    </ContentsBoxGold>

    <ResultNav />
  </div>
</template>

<script>
import store from '@/store/index'

import { ranking } from '@constants/ranking'

import ContentsBoxGold from '@components/contents-box-gold/index.vue'
import ResultNav from '@components/result/nav.vue'

import localeResult from '@locales/result'
import localeCharacter from '@locales/character'

export default {
  name: 'result-list',
  beforeRouteEnter (to, from, next) {
    if (store.getters['currentState/termType'] >= 3) {
      if (!to.query.page) {
        next({path: to.path, query: {page: 1}})
      } else {
        next()
      }
    } else {
      next('/')
    }
  },
  $messages: { localeResult, localeCharacter},
  components: {
    ContentsBoxGold,
    ResultNav,
  },
  computed: {
    locale() {
      return this.$route.params.lang ? this.$route.params.lang : 'ja-JP'
    },
    sortedRanking() {
      return ranking.map(r => r).sort((a, b) => {
        const rankA = Number(a.rank)
        const rankB = Number(b.rank)
        if (rankA > rankB) return 1
        if (rankA < rankB) return -1
        return 0
      })
    },
  },
  watch: {
    '$route.params.lang'(){
      if (!this.$route.query.page) {
        this.$router.replace({ path:`/${this.locale}/result-list`, query: {page: 1}},() => {}, () => {})
      }
    }
  },
  methods: {
    heroName(heroId) {
      return this.$t(heroId, null, 'localeCharacter')
    },
    ranklist(page){
      switch (Number(page)) {
        case 1:
          return this.sortedRanking.filter(s => Number(s.rank) <= 100)
        case 2:
          return this.sortedRanking.filter(s => Number(s.rank) > 100)
        default:
          return null
      }
    },
    localeFigure(count) {
      const locale = this.$route.params.lang
      const num = String(count)
      if (locale === 'de-DE' || locale === 'es-ES' || locale === 'es-MX' || locale === 'fr-CA' || locale === 'fr-FR') {
        return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ')
      } else if (locale === 'it-IT' || locale === 'it-IT' || locale === 'pt-BR') {
        return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      } else {
        return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.result-list {
  margin-bottom: 34px;
}

.contents-box {
  margin-top: 177px;
  background: url(#{$img-path}contents-box-gold/bg_middle.png) repeat-y center 0;
  > .title {
    width: 628px;
    height: 207px;
    margin-top: -220px;
    position: relative;
    background: url(#{$img-path}result/bg_title.png) no-repeat 0 0;
    .text {
      height: 75px;
      width: 100%;
      position: absolute;
      top: 117px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .nav-result {
    margin: 0 51px;
  }
}

.ranking-table {
  border-style: solid;
  border-image: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,224,0.01) 1%,rgba(255,255,224,0.01) 2%,rgba(255,255,225,0.09) 4%,rgba(255,255,226,0.24) 6%,rgba(255,255,227,0.61) 8%,rgba(255,255,228,0.73) 10%,rgba(255,255,229,0.8) 12%,rgba(255,255,252,0.8) 88%,rgba(255,255,253,0.72) 90%,rgba(255,255,253,0.61) 92%,rgba(255,255,254,0.26) 94%,rgba(255,255,254,0.12) 95%,rgba(255,255,255,0.02) 97%,rgba(255,255,255,0.01) 99%,rgba(255,255,255,0) 100%);
  border-image-slice: 1;
  border-image-width: 3px 0 3px 0;
  background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(38,34,19,0.01) 1%,rgba(38,34,19,0.02) 2%,rgba(38,34,19,0.07) 4%,rgba(38,34,19,0.14) 5%,rgba(38,34,19,0.23) 6%,rgba(38,34,19,0.57) 8%,rgba(38,34,19,0.68) 10%,rgba(38,34,19,0.75) 12%,rgba(38,34,19,0.75) 88%,rgba(38,34,19,0.65) 90%,rgba(38,34,19,0.57) 92%,rgba(38,34,19,0.27) 94%,rgba(38,34,19,0.19) 95%,rgba(38,34,19,0.07) 96%,rgba(38,34,19,0) 98%,rgba(38,34,19,0) 99%,rgba(255,255,255,0) 100%);
  width: 577px;
  margin: 33px auto 0;
  .ranking {
    text-align: center;
    width: 112px;
    box-sizing: border-box;
    padding-left: 5px;
  }
  .name {
    text-align: left;
    line-height: 1.3;
  }
  .vote {
    text-align: right;
    padding-right: 30px;
  }
  th, td {
    padding: 20px 0;
  }
  thead th {
    font-weight: normal;
    font-size: $fs-large;
  }
  tbody tr {
    position: relative;
    .ranking,
    .vote {
      font-size: $fs-xlarge;
    }
    .name {
      font-size: $fs-large * 1.4;
    }
    .another-name {
      font-size: $fs-large;
    }
    &::after {
      position: absolute;
      display: block;
      left: 0;
      content: "";
      width: 100%;
      height: 1px;
      background: url(#{$img-path}result/line.png) no-repeat center 0;
    }
  }
}

</style>
